import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useIppool from "../../../../hooks/useIppool";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../../utils/common";
import { OperatorConstants } from "../../../../constants/operator.constants";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    ippoolNameOperator: "eq",
    fromIpOperator: "eq",
    toIpOperator: "eq",
    ippoolName: [],
    fromIp: "",
    toIp: "",
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const { autoSearchIppool, ippoolAutoSearchResults, isLoadingAutoSearch } = useIppool();

  const [ippoolPayload, setIppoolPayload] = useState(currentPayload);
  const [ippoolOptions, setIppoolOptions] = useState([]);
  const [ippoolMultiValue, setIppoolMultiValue] = useState(false);
  const [defaultIppool, setDefaultIppool] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const ippoolOpValue = watch("ippoolNameOperator");

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.ippoolName != null && Object.keys(data.ippoolName).length != 0) {
        filters.push({
          fieldName: "ipPoolId",
          fieldValue: convertedValue(data.ippoolName, "value").join(","),
          op: data.ippoolNameOperator,
          dataType: "int",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.fromIp != "" && data.fromIp != null) {
        filters.push({
          fieldName: "fromIp",
          fieldValue: data.fromIp,
          op: data.fromIpOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.toIp != "" && data.toIp != null) {
        filters.push({
          fieldName: "toIp",
          fieldValue: data.toIp,
          op: data.toIpOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (ippoolOpValue == "in" || ippoolOpValue == "nin") {
      setDefaultIppool([]);
      setValue("ippoolName", []);
      setIppoolMultiValue(true);
    } else {
      setDefaultIppool({});
      setValue("ippoolName", {});
      setIppoolMultiValue(false);
    }
  }, [ippoolOpValue]);

  const fetchIppool = async () => {
    await autoSearchIppool(ippoolPayload);
  };
  useEffect(() => {
    fetchIppool();
  }, [ippoolPayload]);

  useEffect(() => {
    if (ippoolAutoSearchResults.data.length !== 0) {
      setIppoolOptions([...ippoolOptions, ...ippoolAutoSearchResults.data]);
    }
  }, [ippoolAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={8.5} sm={12} md={6} lg={6} xl={6}>
              <ReactHookFormSelect
                name="ippoolNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={8.5} sm={12} md={6} lg={6} xl={6}>
              <SearchableAutoComplete
                control={control}
                data={ippoolOptions}
                label="Ippool Name"
                payload={ippoolPayload}
                setPayload={setIppoolPayload}
                loading={isLoadingAutoSearch}
                name="ippoolName"
                multiple={ippoolMultiValue}
                defaultValue={defaultIppool}
              />
            </Grid>
            <Grid item xs={8.5} sm={12} md={6} lg={6} xl={6}>
              <ReactHookFormSelect
                name="fromIpOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={8.5} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("from_ip")}
                name="fromIp"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item xs={8.5} sm={12} md={6} lg={6} xl={6}>
              <ReactHookFormSelect
                name="toIpOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={8.5} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("to_ip")}
                name="toIp"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
